<div class="text-center d-block" *ngIf="rowData.workStatus">
	<div class="badge badge-danger">
		{{ 'EMPLOYEES_PAGE.WORK_ENDED' | translate }}
	</div>
	{{ rowData.workStatus }}
</div>
<div
	*ngIf="!rowData.startedWorkOn"
	nbTooltip="{{ 'EMPLOYEES_PAGE.NOT_STARTED_HELP' | translate }}"
>
	<div class="badge badge-disabled">
		{{ 'EMPLOYEES_PAGE.NOT_STARTED' | translate }}
	</div>
</div>
<div *ngIf="rowData.startedWorkOn && rowData.isActive && !rowData.workStatus">
	<div class="badge badge-success">
		{{ 'EMPLOYEES_PAGE.ACTIVE' | translate }}
	</div>
</div>
<div *ngIf="rowData.startedWorkOn && !rowData.isActive">
	<div class="badge badge-danger">
		{{ 'EMPLOYEES_PAGE.DELETED' | translate }}
	</div>
</div>
